// extracted by mini-css-extract-plugin
module.exports = {"root":"PriceFilterPopup_root__3ZZZa","label":"PriceFilterPopup_label__jIuRI","labelSelected":"PriceFilterPopup_labelSelected__111PK"};